import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";

export function EmailPreviewDialog({ preview, onClose }) {
  return (
    <Dialog open={Boolean(preview)} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-2xl border-2 border-black p-0" data-testid="email-preview-dialog">
        {preview && (
          <>
            <DialogHeader className="border-b-2 border-black bg-[#FACC15] px-6 py-4 text-left">
              <DialogTitle className="font-display text-lg font-bold" data-testid="email-preview-subject">{preview.subject}</DialogTitle>
              <DialogDescription className="text-black/80">
                To: {preview.to_email || "—"} · Status: {preview.status}
                {preview.error ? ` · ${preview.error}` : ""}
              </DialogDescription>
            </DialogHeader>
            <iframe title="Email preview" srcDoc={preview.body_html} className="h-[520px] w-full bg-[#FFFBEB]" sandbox="" data-testid="email-preview-frame" />
          </>
        )}
      </DialogContent>
    </Dialog>
  );
}
